// extracted by mini-css-extract-plugin
module.exports = {"listB":"listB_listB__X_7bg"};